module.exports = __webpack_public_path__ + "static/media/calendar.efb27e0c.png";